import { useEffect, type RefObject } from 'react';

import { startReportAttentionTracking } from '@/lib/reportAttention';

type UsePostHogReportAttentionParams = {
  enabled?: boolean;
  reportId?: string | null;
  editionSessionCount?: number;
  containerRef?: RefObject<HTMLElement | null>;
};

export const usePostHogReportAttention = ({
  enabled = true,
  reportId,
  editionSessionCount = 0,
  containerRef,
}: UsePostHogReportAttentionParams) => {
  useEffect(() => {
    if (!enabled || !reportId) return;

    const root = containerRef?.current ?? document;
    return startReportAttentionTracking(reportId, {
      root,
      editionSessionCount,
    });
  }, [enabled, reportId, editionSessionCount, containerRef]);
};
